import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'ngf-opt-hint',
    templateUrl: './opt-hint.component.html',
    styleUrls: ['./opt-hint.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class OptHintComponent {}
